import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-redux-i18n';

import GenericDatePicker from '../../../Common/GenericDatePicker';
import GenericSelection from '../../../Common/GenericSelection';
import { isLMH, isSDR, isCRW, isOLG } from '../../../../actions/root_url';

const propTypes = {
  startDateSelected: PropTypes.instanceOf(Date),
  endDateSelected: PropTypes.instanceOf(Date),
  customerGroupSelected: PropTypes.string,
  paymentTypeSelected: PropTypes.string,
  customerOptions: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  })),
  setStartDate: PropTypes.func,
  setEndDate: PropTypes.func,
  handleSelectionChange: PropTypes.func,
};

const defaultProps = {
  startDateSelected: undefined,
  endDateSelected: undefined,
  customerGroupSelected: '',
  paymentTypeSelected: '',
  customerOptions: [],
  setStartDate: () => {},
  setEndDate: () => {},
  handleSelectionChange: () => {},
};


const PromotionSetup = ({
  setStartDate,
  startDateSelected,
  setEndDate,
  endDateSelected,
  handleSelectionChange,
  customerGroupSelected,
  paymentTypeSelected,
  customerOptions,
}) => {
  const paymentOptions = [
    { label: <Translate value="mobile" />, value: 'Mobile' },
    { label: <Translate value="pos" />, value: 'POS' },
    { label: <Translate value="cash" />, value: 'Cash' },
    // { label: 'Card', value: 'Card' },
    // { label: 'Check', value: 'Check' },
    { label: <Translate value="all" />, value: 'All' },
  ];
  if (isOLG || isLMH || isSDR || isCRW) {
    const posIndex = paymentOptions.findIndex(item => item.value === 'POS');
    if (posIndex !== -1) {
      paymentOptions.splice(posIndex, 2);
    }
  }
  return (
    <div className="promo-setup">
      <div className="flex-row">
        <label htmlFor="start-date-picker" className="start-date-label"><Translate value="start_date" />:</label>
        <GenericDatePicker
          id="start-date-picker"
          setDate={setStartDate}
          selectedDate={startDateSelected}
          onChange={setStartDate}
        />
      </div>
      <div className="flex-row">
        <label htmlFor="end-date-picker" className="end-date-label"><Translate value="end_date" />:</label>
        <GenericDatePicker
          id="end-date-picker"
          setDate={setEndDate}
          selectedDate={endDateSelected}
          onChange={setEndDate}
        />
      </div>
      <div className="customer-group-selection">
        <GenericSelection
          translation={<Translate value="customers" />}
          setSelected={({ value }) => handleSelectionChange(value, 'customerGroupSelected')}
          value={customerGroupSelected}
          options={customerOptions}
          colon
        />
      </div>
      <div className="payment-type-selection">
        <GenericSelection
          translation={<Translate value="payment" />}
          setSelected={({ value }) => handleSelectionChange(value, 'paymentTypeSelected')}
          value={paymentTypeSelected}
          options={paymentOptions}
          colon
        />
      </div>
    </div>
  );
};

PromotionSetup.propTypes = propTypes;
PromotionSetup.defaultProps = defaultProps;

export default PromotionSetup;



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/PromotionsPage/components/PromotionSetup.jsx